import { inject, observer } from 'mobx-react'
import React from 'react'
import CopyGeometryTooltip from 'components/common/tooltips/CopyGeometryTooltip'
import { withTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { Copy01Icon } from '@hugeicons/core-free-icons'

const CopyGeometryButton = ({ title, group, onSubmit, uiStore, dataStore, lgIcon, t }) => (
  <button
    className='nooutline copy-geometry'
    onClick={(e) => {
      e.stopPropagation()
      dataStore.selectedCopyGroup = null
      uiStore.openClickTooltip({
        style: {
          width: 340
        },
        position: 'right-start',
        selector: '.tools.popup-menu',
        text: (
          <CopyGeometryTooltip
            title={title || t('GLOBAL.COPY_REGION', { defaultValue: 'Copy region' })}
            group={group}
            onSubmit={onSubmit}
          />
        )
      })
    }}
  >
    <HugeiconsIcon icon={Copy01Icon} size={18} className='popup-menu__icon' />
    <span>{t('GLOBAL.COPY_REGION')}</span>
  </button>
)

export default withTranslation()(inject('uiStore', 'dataStore')(observer(CopyGeometryButton)))
